/** Whole-line fade-in (subtitle stagger after headline TypeIn). */
export default function FadeInLine({
  text,
  delay,
  block = false,
}: {
  text: string;
  delay: number;
  block?: boolean;
}) {
  return (
    <span
      className={block ? "fadein-line fadein-line-block" : "fadein-line"}
      style={{ animationDelay: delay.toFixed(3) + "s" }}
    >
      {text}
    </span>
  );
}
